import { render, staticRenderFns } from "./myClassInfo.vue?vue&type=template&id=b426e38a&scoped=true"
import script from "./myClassInfo.vue?vue&type=script&lang=js"
export * from "./myClassInfo.vue?vue&type=script&lang=js"
import style0 from "./myClassInfo.vue?vue&type=style&index=0&id=b426e38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b426e38a",
  null
  
)

export default component.exports